// extracted by mini-css-extract-plugin
export default {"avatars":"MultipleAnswers_avatars__GIizJ","avatarItem":"MultipleAnswers_avatarItem__KS+EU"};